import React from 'react'
import PropTypes from 'prop-types'

import { Text, TileToggle } from 'passiv-components'

const InOut = ({ name, ariaLabel, occupancy, untilTimeText, onToggleClick, onUntilTimeClick }) => {
  return (
    <>
      <Text
        type="title-condensed"
        className="sm:menu-tile-title absolute pt-2 top-0 w-full text-center"
        ariaLabel={ariaLabel}
      >
        {name}
      </Text>
      <TileToggle status={occupancy[0].type === 'VACATION' ? 'AWAY' : occupancy[0].type} onToggleClick={onToggleClick} />
      {occupancy[0].type === 'OUT' && untilTimeText && (
        <Text
          type="body"
          className="absolute z-20 bottom-0 pb-2 text-blue text-center w-full cursor-pointer"
          ariaRole="button"
          onClick={onUntilTimeClick}
        >
          {untilTimeText}
        </Text>
      )}
    </>
  )
}

InOut.propTypes = {
  name: PropTypes.string,
  occupancy: PropTypes.array,
  untilTimeText: PropTypes.string,
  onClick: PropTypes.func
}

export default InOut
